var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.adjustedCombinations),function(combination,index){return _c('v-col',{key:index},[_c('v-card',{attrs:{"flat":""}},[_c('apexchart',{ref:'chart' + index,refInFor:true,attrs:{"type":"line","height":"350","options":{ ..._vm.lineChartOptions },"series":combination}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }